/**
 * Returns true if `array` is empty.
 */
export const isEmptyArray = (array) => {
    return array.length === 0;
};
//# sourceMappingURL=is-empty-array.js.map